import { render, staticRenderFns } from "./PlaceOrder.vue?vue&type=template&id=4beba356&scoped=true&"
import script from "./PlaceOrder.vue?vue&type=script&lang=ts&"
export * from "./PlaceOrder.vue?vue&type=script&lang=ts&"
import style0 from "./PlaceOrder.vue?vue&type=style&index=0&id=4beba356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beba356",
  null
  
)

export default component.exports